// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.share-campaign-model .ant-modal .ant-modal-content {
  position: relative;
  background-color: #ffffff;
  background-clip: padding-box;
  border: 0;
  border-radius: 8px;
  box-shadow: none !important;
  pointer-events: auto;
  padding: 20px 30px;
}

.share-camapign-model-header {
  color: var(--Colors-Text-500, #0a0f0d);
  font-family: Montserrat;
  font-size: var(--Font-Font-Size-h5, 23px);
  padding-bottom: 30px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}

.share-campaign-model-warn {
  display: flex;
  padding: 8px 20px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 5px;
  background: #ffe8ec;
}

.share-campaign-model-warn .share-campaign-text {
  flex-shrink: 0;
  color: var(--Colors-Primary-500, #d2042d);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}

.share-campaign-cancel-btn {
  display: inline-flex;
  height: 44px;
  padding: 8px 20px;
  justify-content: center;
  align-items: center;
  border: none;
  border-radius: 3px;
  background: #f0f0f0;
}

.share-campaign-send-btn {
  color: #fff;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  display: inline-flex;
  height: 44px;
  padding: 8px 20px;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  border: none;
  background: var(--Colors-Primary-500, #d2042d);
}

.share-cancel {
  color: var(--Colors-Text-500, #0a0f0d);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-right: 15px;
}
.share-send {
  color: #fff;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.need-help-text {
  font-family: Roboto;
  color: #000;
  font-size: 13px;
  padding-left: 50px;
  margin-top: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}
.ant-typography a {
  color: var(--Colors-Primary-500, #d2042d) !important;
  text-decoration-line: underline !important;
  font-size: 13px !important;
  font-weight: 400;
  outline: none;
  line-height: 24px;
  cursor: pointer;
  transition: all 0.3s !important;
  border: 0;
  padding: 0;
  background: none;
  -webkit-user-select: text;
          user-select: text;
}
.ant-typography a:hover {
  color: var(--Colors-Primary-500, #d2042d);
  text-decoration-line: underline;
  font-size: 13px;
  font-weight: 400;
  outline: none;
  line-height: 24px;
  cursor: pointer;
  transition: all 0.3s;
  border: 0;
  padding: 0;
  background: none;
  -webkit-user-select: text;
          user-select: text;
}
.recipient-input-field {
  height: 3.125rem;
  padding: 0.625rem 1.25rem !important;
  align-items: center;
  margin-top: 0;
  font-size: 1rem;
  border-radius: 0.3125rem !important;
  border-bottom: 1px solid var(--Colors-Text-400, #3b3f3d) !important;
  background: #fcfcfc !important;
}

@media (width <= 425px) {
  .share-campaign-model-warn {
    display: flex;
    width: 100%;
    padding: 8px 20px;
    justify-content: center;
    text-align: center;
    align-items: center;
    gap: 8px;
    border-radius: 5px;
    background: #ffe8ec;
  }
  .share-campaign-model-warn .share-campaign-text {
    width: 100%;
    flex-shrink: 0;
    color: var(--Colors-Primary-500, #d2042d);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
  }
  .need-help-text {
    color: #000;
    font-size: 13px;
    padding-left: 0px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
  }
}
@media (width <= 400px) {
  .share-campaign-model-warn {
    display: flex;
    width: 312px;
    padding: 8px 20px;
    justify-content: center;
    text-align: center;
    align-items: center;
    gap: 8px;
    border-radius: 5px;
    background: #ffe8ec;
  }
  .share-campaign-model-warn .share-campaign-text {
    width: 100%;
    flex-shrink: 0;
    color: var(--Colors-Primary-500, #d2042d);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/modal/share-campaign-modal/ShareCampaign.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,4BAA4B;EAC5B,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;EACvB,yCAAyC;EACzC,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,yCAAyC;EACzC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,oDAAoD;EACpD,0CAA0C;EAC1C,0BAA0B;EAC1B,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,+BAA+B;EAC/B,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,yCAAyC;EACzC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,mCAAmC;EACnC,mEAAmE;EACnE,8BAA8B;AAChC;;AAEA;EACE;IACE,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,cAAc;IACd,yCAAyC;IACzC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;AACF;AACA;EACE;IACE,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,cAAc;IACd,yCAAyC;IACzC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;AACF","sourcesContent":[".share-campaign-model .ant-modal .ant-modal-content {\n  position: relative;\n  background-color: #ffffff;\n  background-clip: padding-box;\n  border: 0;\n  border-radius: 8px;\n  box-shadow: none !important;\n  pointer-events: auto;\n  padding: 20px 30px;\n}\n\n.share-camapign-model-header {\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-family: Montserrat;\n  font-size: var(--Font-Font-Size-h5, 23px);\n  padding-bottom: 30px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 24px;\n}\n\n.share-campaign-model-warn {\n  display: flex;\n  padding: 8px 20px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  border-radius: 5px;\n  background: #ffe8ec;\n}\n\n.share-campaign-model-warn .share-campaign-text {\n  flex-shrink: 0;\n  color: var(--Colors-Primary-500, #d2042d);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n}\n\n.share-campaign-cancel-btn {\n  display: inline-flex;\n  height: 44px;\n  padding: 8px 20px;\n  justify-content: center;\n  align-items: center;\n  border: none;\n  border-radius: 3px;\n  background: #f0f0f0;\n}\n\n.share-campaign-send-btn {\n  color: #fff;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  display: inline-flex;\n  height: 44px;\n  padding: 8px 20px;\n  justify-content: center;\n  align-items: center;\n  border-radius: 3px;\n  border: none;\n  background: var(--Colors-Primary-500, #d2042d);\n}\n\n.share-cancel {\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  margin-right: 15px;\n}\n.share-send {\n  color: #fff;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.need-help-text {\n  font-family: Roboto;\n  color: #000;\n  font-size: 13px;\n  padding-left: 50px;\n  margin-top: 20px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n}\n.ant-typography a {\n  color: var(--Colors-Primary-500, #d2042d) !important;\n  text-decoration-line: underline !important;\n  font-size: 13px !important;\n  font-weight: 400;\n  outline: none;\n  line-height: 24px;\n  cursor: pointer;\n  transition: all 0.3s !important;\n  border: 0;\n  padding: 0;\n  background: none;\n  user-select: text;\n}\n.ant-typography a:hover {\n  color: var(--Colors-Primary-500, #d2042d);\n  text-decoration-line: underline;\n  font-size: 13px;\n  font-weight: 400;\n  outline: none;\n  line-height: 24px;\n  cursor: pointer;\n  transition: all 0.3s;\n  border: 0;\n  padding: 0;\n  background: none;\n  user-select: text;\n}\n.recipient-input-field {\n  height: 3.125rem;\n  padding: 0.625rem 1.25rem !important;\n  align-items: center;\n  margin-top: 0;\n  font-size: 1rem;\n  border-radius: 0.3125rem !important;\n  border-bottom: 1px solid var(--Colors-Text-400, #3b3f3d) !important;\n  background: #fcfcfc !important;\n}\n\n@media (width <= 425px) {\n  .share-campaign-model-warn {\n    display: flex;\n    width: 100%;\n    padding: 8px 20px;\n    justify-content: center;\n    text-align: center;\n    align-items: center;\n    gap: 8px;\n    border-radius: 5px;\n    background: #ffe8ec;\n  }\n  .share-campaign-model-warn .share-campaign-text {\n    width: 100%;\n    flex-shrink: 0;\n    color: var(--Colors-Primary-500, #d2042d);\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n  }\n  .need-help-text {\n    color: #000;\n    font-size: 13px;\n    padding-left: 0px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n  }\n}\n@media (width <= 400px) {\n  .share-campaign-model-warn {\n    display: flex;\n    width: 312px;\n    padding: 8px 20px;\n    justify-content: center;\n    text-align: center;\n    align-items: center;\n    gap: 8px;\n    border-radius: 5px;\n    background: #ffe8ec;\n  }\n  .share-campaign-model-warn .share-campaign-text {\n    width: 100%;\n    flex-shrink: 0;\n    color: var(--Colors-Primary-500, #d2042d);\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
